import { render, staticRenderFns } from "./LLButton.vue?vue&type=template&id=b88bf20e&scoped=true"
import script from "./LLButton.vue?vue&type=script&lang=js"
export * from "./LLButton.vue?vue&type=script&lang=js"
import style0 from "./LLButton.vue?vue&type=style&index=0&id=b88bf20e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88bf20e",
  null
  
)

export default component.exports